import 'css-chunksrc/client/common/projectsSelection/section/styles.scss';export default {
  "header": "_header_ja206_1",
  "iconBox": "_iconBox_ja206_10",
  "icon": "_icon_ja206_10",
  "open": "_open_ja206_28"
};